import { Checkbox, FormControlLabel } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { CheckboxFormFieldProps } from '@zealth/core/formFields/types'

export const CheckboxFormField = ({ label }: CheckboxFormFieldProps) => {
  const field = useFieldContext<boolean>()

  return (
    <FormControlLabel
      label={label}
      labelPlacement="end"
      control={
        <Checkbox
          checked={field.state.value}
          onChange={e => field.handleChange(e.target.checked)}
        />
      }
    />
  )
}
